var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pay-info{padding:1rem .5rem}.qrcode-info{padding:.75rem;position:relative}.erweima{margin-top:.133333rem;height:4.666667rem;width:4.666667rem;background:url(" + escape(require("../../../static/img/mohuewm.png")) + ") no-repeat;background-size:contain;position:absolute;top:12%;left:26%}.refresh-btn{text-align:center;position:absolute;background-color:#fff;width:7.75rem;height:2rem;border-radius:.666667rem;line-height:2rem;color:#39c451;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3aaf23e2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/pay/SelfPay.vue
// module id = 434
// module chunks = 0